import { useState } from "react";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import * as Icons from "lucide-react";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLogin = ({ onLoginSuccess }) => {
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch(`${BACKEND_URL}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        // Save token to localStorage
        localStorage.setItem("adminToken", data.token);
        localStorage.setItem("adminTokenExpiry", Date.now() + 24 * 60 * 60 * 1000); // 24h
        
        toast.success("Login erfolgreich!");
        onLoginSuccess();
      } else {
        toast.error(data.detail || "Login fehlgeschlagen");
        setPassword("");
      }
    } catch (error) {
      console.error("Login error:", error);
      toast.error("Verbindungsfehler. Bitte versuchen Sie es erneut.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-[#1f7db6] rounded-full flex items-center justify-center mb-4">
            <Icons.Lock className="text-white" size={32} />
          </div>
          <CardTitle className="text-2xl font-bold text-[#143e6e]">
            Admin Login
          </CardTitle>
          <p className="text-gray-600 mt-2">
            Bitte geben Sie Ihr Admin-Passwort ein
          </p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="password">Passwort</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                autoFocus
                className="mt-1"
              />
            </div>

            <Button
              type="submit"
              disabled={isLoading || !password}
              className="w-full bg-[#1f7db6] hover:bg-[#143e6e] text-white"
            >
              {isLoading ? (
                <>
                  <Icons.Loader2 className="mr-2 animate-spin" size={18} />
                  Login...
                </>
              ) : (
                <>
                  <Icons.LogIn className="mr-2" size={18} />
                  Einloggen
                </>
              )}
            </Button>
          </form>

          <div className="mt-6 text-center text-sm text-gray-600">
            <p>
              <Icons.Info className="inline mr-1" size={14} />
              Token gültig für 24 Stunden
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
